<template>
  <div class="basic_wrap">
    <!-- ================= 1. 顶部用户信息卡片 ================= -->
    <div class="card_box user_profile_card">
      <div class="profile_top">
        <div class="avatar_box">
          <img :src="data.user_icon" alt="avatar">
        </div>
        <div class="info_mid">
          <div class="user_name">{{ data.username }}</div>
          <div class="user_tags">
            <span class="uid_tag">UID: {{ data.uid }}</span>
            <span class="vip_tag">{{ data.vip_name }}</span>
          </div>
        </div>
      </div>

      <!-- 2x2 财务数据四宫格 -->
      <div class="finance_grid">
        <div class="f_item">
          <div class="f_label">{{ $t('utils.lunlog43') }}</div>
          <div class="f_val green">{{ common.currency_symbol_basic() }}{{ common.precision_basic(fundBalanceUsd) }}</div>
        </div>
        <div class="f_item">
          <div class="f_label">{{ $t('utils.lunlog42') }}</div>
          <div class="f_val black">{{ common.currency_symbol_basic() }}{{ common.precision_basic(money_r) }}</div>
        </div>
        <div class="f_item">
          <div class="f_label">{{ $t('utils.msg5') }}</div>
          <div class="f_val blue">{{ common.currency_symbol_basic() }}{{ common.precision_basic(data.invest_money) }}</div>
        </div>
        <div class="f_item">
          <div class="f_label">{{ $t('utils.msg6') }}</div>
          <div class="f_val orange">{{ common.currency_symbol_basic() }}{{ common.precision_basic(data.wait_interest) }}</div>
        </div>
      </div>
    </div>

    <!-- ================= 2. 快捷大按钮 (充值 / 提现) ================= -->
    <div class="quick_actions">
      <div class="action_card" @click="$router.push('/recharge')">
        <div class="icon_box blue_light">
			 <img :src="require('../img/index/receive.png')" alt="" style="width: 32px;height: 32px;;">
		</div>
        <div class="action_title">{{ $t('user.recharge') }}</div>
      </div>
      <div class="action_card" @click="$router.push('/withdraw')">
        <div class="icon_box orange_light">
			<img :src="require('../img/index/send.png')" alt="" style="width: 32px;height: 32px;;">
		</div>
        <div class="action_title">{{ $t('user.withdraw') }}</div>
      </div>
    </div>

    <!-- ================= 3. 菜单列表 (完美复刻图二) ================= -->
    <div class="card_box menu_list_card">
      
      <!-- 投资记录 -->
      <div class="menu_item" @click="$router.push('/invest/record')">
        <div class="item_left">
          <div class="icon_bg green_light">
          		  <img :src="require('../img/user/order.png')" alt=""  style="width: 32px;height: 32px;;">
          	  </div>
          <span class="item_text">{{ $t('user.inviteRecord') || '投资记录' }}</span>
        </div>
        <div class="arrow_right">›</div>
      </div>

      <!-- 充值记录 -->
      <div class="menu_item" @click="$router.push('/recharge/record')">
        <div class="item_left">
          <div class="icon_bg green_light">
          		  <img :src="require('../img/user/recharge.png')" alt=""  style="width: 32px;height: 32px;;">
          	  </div>
          <span class="item_text">{{ $t('user.rechargeRecord') }}</span>
        </div>
        <div class="arrow_right">›</div>
      </div>

      <!-- 提现记录 -->
      <div class="menu_item" @click="$router.push('/withdraw/record')">
        <div class="item_left">
          <div class="icon_bg green_light">
          		  <img :src="require('../img/user/cash.png')" alt=""  style="width: 32px;height: 32px;;">
          	  </div>
          <span class="item_text">{{ $t('user.withdrawRecord') }}</span>
        </div>
        <div class="arrow_right">›</div>
      </div>
	<div class="menu_item" @click="$router.push('/wallet')">
	  <div class="item_left">
	    <div class="icon_bg green_light">
	    		  <img :src="require('../img/user/moneybag.png')" alt=""  style="width: 32px;height: 32px;;">
	    	  </div>
	    <span class="item_text">{{ $t('user.withdrawAccount') }}</span>
	  </div>
	  <div class="arrow_right">›</div>
	</div>
      <!-- 资金明细 -->
      <div class="menu_item" @click="$router.push('/funding/record')">
        <div class="item_left">
          <div class="icon_bg green_light">
          		  <img :src="require('../img/user/detailss.png')" alt=""  style="width: 32px;height: 32px;;">
          	  </div>
          <span class="item_text">{{ $t('user.fundingDetails') }}</span>
        </div>
        <div class="arrow_right">›</div>
      </div>
	<div class="menu_item" @click="$router.push('/rewards')">
	  <div class="item_left">
	    <div class="icon_bg green_light">
				  <img :src="require('../img/user/rewards.png')" alt=""  style="width: 32px;height: 32px;;">
			  </div>
	    <span class="item_text">{{ $t('user.rewards')  }}</span>
	  </div>
	  <div class="arrow_right">›</div>
	</div>
      <!-- 会员中心 (对应图二，您可根据实际路由调整) -->
      <div class="menu_item" @click="$router.push('/vip')">
        <div class="item_left">
          <div class="icon_bg green_light">
          		  <img :src="require('../img/user/vip.png')" alt=""  style="width: 32px;height: 32px;;">
          	  </div>
          <span class="item_text">{{ $t('user.vip') }}</span>
        </div>
        <div class="arrow_right">›</div>
      </div>

      <!-- 修改密码 -->
      <div class="menu_item" @click="$router.push('/setpwd')">
        <div class="item_left">
          <div class="icon_bg green_light">
          		  <img :src="require('../img/user/secret.png')" alt=""  style="width: 32px;height: 32px;;">
          	  </div>
          <span class="item_text">{{ $t('utils.lunlog19') }}</span>
        </div>
        <div class="arrow_right">›</div>
      </div>

      <!-- 语言偏好 -->
      <div class="menu_item" @click="$router.push('/language')">
        <div class="item_left">
          <div class="icon_bg green_light">
          		  <img :src="require('../img/user/language.png')" alt=""  style="width: 32px;height: 32px;;">
          	  </div>
          <span class="item_text">{{ $t('user.languagePreference') }}</span>
        </div>
        <div class="arrow_right">›</div>
      </div>

      <!-- 常见问题 -->
      <div class="menu_item" @click="$router.push('/questions')">
        <div class="item_left">
          <div class="icon_bg green_light">
          		  <img :src="require('../img/user/question.png')" alt=""  style="width: 32px;height: 32px;;">
          	  </div>
          <span class="item_text">{{ $t('user.faq') }}</span>
        </div>
        <div class="arrow_right">›</div>
      </div>

      <!-- 官方频道 (示意，可根据实际调整图标和链接) -->
      <div class="menu_item" @click="services1">
        <div class="item_left">
          <div class="icon_bg green_light">
			  <img :src="require('../img/index/tg.png')" alt=""  style="width: 32px;height: 32px;;">
		  </div>
          <span class="item_text">{{ $t('utils.gfpd') || '官方频道' }}</span>
        </div>
        <div class="arrow_right">›</div>
      </div>
	  <div class="menu_item" @click="services">
	    <div class="item_left">
	      <div class="icon_bg green_light">
	  			  <img :src="require('../img/index/ws.png')" alt="" style="width: 32px;height: 32px;;">
	  		  </div>
	      <span class="item_text">{{ $t('utils.gfpd') || '官方频道' }}</span>
	    </div>
	    <div class="arrow_right">›</div>
	  </div>

    </div>

    <!-- ================= 4. 退出登录大按钮 ================= -->
    <button class="logout_btn" @click="logout">
      {{ $t('user.signOut') }}
    </button>
    
    <div style="height: 70px;"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { openServiceUrl, openUrl } from '../../utils/openUrl';
import Clipboard from "v-clipboard";
import { Icon, Cell, CellGroup } from "vant";

Vue.use(Cell).use(CellGroup).use(Icon).use(Clipboard);

export default {
  name: "User",
  components: {},
  data() {
    return {
      currency: '',
      data: {},
      fundBalance: 0.00,
      fundBalanceUsd: 0.00,
      money_r: 0.00,
      savings: 0.00,
      eye: 1,
      service: [],
      signinStatue: false
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user');
  },
  mounted() {
    this.start();
  },
  methods: {
    jump(url) {
      openUrl(url, this.$router);
    },
    services() {
      //alert(this.service.ws)
	  window.location.href = this.service.ws;
    },services1() {
     window.location.href = this.service.tg;
    },
    start() {
      var isapp = 0;
      if (window.plus) {
        isapp = 1;
      }
      Fetch('/user/info', {
        isapp: isapp
      }).then((r) => {
        this.data = r.data;
        this.fundBalance = r.data.fundBalance;
        this.fundBalanceUsd = r.data.fundBalanceUsd;
        this.money_r = r.data.money_r;
        this.currency = r.data.currency;
        this.signinStatue = r.data.signin;
      });
	  Fetch('/index/int').then((r) => {
	    this.service = r.data.service ? r.data.service : [];
	    // this.projects = r.data.projects; // 如果后台有下发投资项目，解开注释
	  });
    },
    logout() {
      localStorage.removeItem('token');
      this.$store.commit('setLogout');
      this.$router.replace("/login");
    }
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  padding: 16px 14px 60px;
  min-height: 100vh;
  /* 还原截图中的浅色网格纹理背景 */
background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
}

/* ================= 通用纯白卡片 ================= */
.card_box {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 4px 16px rgba(24, 61, 122, 0.06);
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid rgba(220, 229, 239, 0.5);
}

/* ================= 1. 顶部用户信息卡片 ================= */
.user_profile_card {
  .profile_top {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    
    .avatar_box {
      width: 54px; height: 54px;
      border-radius: 50%; overflow: hidden;
      flex-shrink: 0;
      img { width: 100%; height: 100%; object-fit: cover; }
    }
    
    .info_mid {
      flex: 1;
      .user_name { font-size: 20px; font-weight: 700; color: #111; margin-bottom: 6px; }
      .user_tags { display: flex; gap: 8px; }
      .uid_tag {
        background: #eef2ff; color: #4f46e5;
        padding: 2px 12px; border-radius: 12px;
        font-size: 12px; font-weight: 600;
      }
      .vip_tag {
        background: #fef3c7; color: #d97706;
        padding: 2px 12px; border-radius: 12px;
        font-size: 12px; font-weight: 600;
      }
    }
  }

  /* 财务四宫格 */
  .finance_grid {
    display: grid; grid-template-columns: 1fr 1fr; gap: 12px;
    .f_item {
      background: #f8faff; border-radius: 12px;
      padding: 12px 0; text-align: center;
      .f_label { font-size: 12px; color: #64748b; margin-bottom: 4px; }
      .f_val { font-size: 16px; font-weight: 700; 
        &.green { color: #16a34a; }
        &.black { color: #000; }
        &.blue { color: #2563eb; }
        &.orange { color: #ea580c; }
      }
    }
  }
}

/* ================= 2. 充值/提现大按钮 ================= */
.quick_actions {
  display: flex; gap: 14px; margin-bottom: 16px;
  .action_card {
    flex: 1; background: #ffffff; border-radius: 16px;
    padding: 16px 0; text-align: center;
    border: 1px solid rgba(220, 229, 239, 0.5);
    box-shadow: 0 4px 16px rgba(24, 61, 122, 0.04);
    cursor: pointer; transition: transform 0.2s;
    &:active { transform: scale(0.96); }
    
    .icon_box {
      width: 40px; height: 40px; border-radius: 12px;
      display: inline-flex; align-items: center; justify-content: center;
      font-size: 20px; margin-bottom: 8px;
      &.blue_light { background: #eff6ff; }
      &.orange_light { background: #fff7ed; }
    }
    .action_title { font-size: 15px; font-weight: 600; color: #111; }
  }
}

/* ================= 3. 垂直菜单列表 ================= */
.menu_list_card {
  padding: 8px 0;
  .menu_item {
    display: flex; justify-content: space-between; align-items: center;
    padding: 14px 16px; cursor: pointer; border-bottom: 1px solid #f1f5f9;
    transition: background 0.2s;
    &:last-child { border-bottom: none; }
    &:active { background: #f8faff; }

    .item_left {
      display: flex; align-items: center; gap: 14px;
      .icon_bg {
        width: 36px; height: 36px; border-radius: 10px;
        display: flex; align-items: center; justify-content: center;
        font-size: 18px; flex-shrink: 0;
        &.green { background: #dcfce7; }
        &.teal { background: #ccfbf1; }
        &.black_bg { background: #e2e8f0; }
        &.yellow { background: #fef9c3; }
        &.gold { background: #fef3c7; }
        &.red { background: #fee2e2; }
        &.orange { background: #ffedd5; }
        &.green_light { background: #dcfce7; }
      }
      .item_text { font-size: 15px; font-weight: 500; color: #1e293b; }
    }

    .arrow_right {
      font-size: 20px; color: #94a3b8; font-weight: 300;
    }
  }
}

/* ================= 4. 退出按钮 ================= */
.logout_btn {
  width: 94%; height: 50px; margin: 10px auto 0; display: block;
  background: #ef4444; color: #ffffff;
  border: none; border-radius: 25px;
  font-size: 16px; font-weight: 700; cursor: pointer;
  transition: opacity 0.2s;
  &:active { opacity: 0.85; }
}
</style>